module.exports = __webpack_public_path__ + "assets/images/hypertension_g.93cd9c03.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/risks/hypertension_g.png
// module id = 740
// module chunks = 1